// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/time-outline.svg';

export const TimeOutline = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
